import { render } from "./sharePlanForm.vue?vue&type=template&id=22fb1bbf"
import script from "./sharePlanForm.vue?vue&type=script&lang=js"
export * from "./sharePlanForm.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__